class PluggingRecord {
  constructor(data, config) {
    this.source = data.source
    this.state = data.state
    this.operator = data.operator
    this.operatorNo = data.operator_no
    this.apiNumber = data.api_number
    this.county = data.county
    this.section = data.section
    this.township = data.township
    this.range = data.range
    this.meridian = data.meridian
    this.survey = data.survey
    this.abstract = data.abstract
    this.block = data.block
    this.distanceAndDirecionNearestTown = data.distance_and_direcion_nearest_town
    this.district = data.district
    this.legal = data.legal
    this.quarterCalls = data.quarter_calls
    this.wellname = data.wellname
    this.leaseName = data.lease_name
    this.leaseNumber = data.lease_number
    this.wellNumber = data.well_number
    this.typeOfDocument = data.type_of_document
    this.totalDepth = data.total_depth
    this.wellType = data.well_type
    this.class = data.class
    this.originalCompletionDate = data.original_completion_date
    this.mapDate = data.map_date
    this.plugDate = data.plug_date
    this.effectiveDate = data.effective_date
    this.pluggingReason = data.plugging_reason
    this.fieldName = data.field_name
    this.plugDepth = data.plug_depth
    this.plugBottom = data.plug_bottom
    this.sourceUrl = data.source_url
    this.apiUrl = data.api_url
    this.stateUrl = data.state_url
    this.occUrl = data.occ_url
    this.detailUrl = data.detail_url
    this.orderUrl = data.order_url
    this.attachmentUrl = config.drillingAttachmentEndpoint + data.api_number
  }
}

export default PluggingRecord
